import { types } from "../constants/admintype";

const initialState = {
  employeeListData: [],
  employeeAttendanceData: [],
  employeeLeaveWfhRequestData: [],
  departmentData: [],
  managerData: [],
  assetsData: [],
  shiftData: [],
  leaveData: [],
  wfhData: [],
  branchesData: [],
  adminTicketsData: [],
  loading: false,
  error: null,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EMPLOYEEDATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_EMPLOYEEDATA_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeListData: action.payload,
      };
    case types.GET_EMPLOYEEDATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.GET_ADMINTICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_ADMINTICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        adminTicketsData: action.payload,
      };
    case types.GET_ADMINTICKET_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_EMPLOYEE_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_EMPLOYEE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeAttendanceData: action.payload,
      };
    case types.GET_EMPLOYEE_ATTENDANCE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_EMPLOYEE_LEAVE_WFH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_EMPLOYEE_LEAVE_WFH_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeLeaveWfhRequestData: action.payload,
      };
    case types.GET_EMPLOYEE_LEAVE_WFH_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_ASSETS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_ASSETS_SUCCESS:
      //console.log("assets  payl", action.payload);

      return {
        ...state,
        loading: false,
        assetsData: action.payload,
      };
    case types.GET_ASSETS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        departmentData: action.payload,
      };
    case types.GET_DEPARTMENT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_REPORTING_MANAGER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_REPORTING_MANAGER_SUCCESS:
      return {
        ...state,
        loading: false,
        managerData: action.payload,
      };
    case types.GET_REPORTING_MANAGER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_SHIFT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        shiftData: action.payload,
      };
    case types.GET_SHIFT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_LEAVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_LEAVE_SUCCESS:
    
      return {
        ...state,
        loading: false,
        leaveData: action.payload,
      };
    case types.GET_LEAVE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_WFH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_WFH_SUCCESS:
   
      return {
        ...state,
        loading: false,
        wfhData: action.payload,
      };
    case types.GET_WFH_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case types.GET_BRANCHES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_BRANCHES_SUCCESS:
   
      return {
        ...state,
        loading: false,
        branchesData: action.payload,
      };
    case types.GET_BRANCHES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default adminReducer;
